import type { AnvilCommand } from "./types";

/** A command paired with its flat index in the (filtered) results list. */
export interface GroupedCommand {
  command: AnvilCommand;
  index: number;
}

/** A run of consecutive commands sharing the same `group`. */
export interface AnvilCommandGroup {
  group?: string;
  items: GroupedCommand[];
}

/**
 * Groups results into consecutive runs by `command.group`, preserving the
 * incoming (score) order and each command's flat index (so the renderer can map
 * a grouped item back to the active-highlight index). Consecutive grouping —
 * not collect-by-name — keeps the order score-driven; a group name that recurs
 * non-consecutively yields a second group, by design.
 */
export function groupCommands(commands: AnvilCommand[]): AnvilCommandGroup[] {
  const groups: AnvilCommandGroup[] = [];

  commands.forEach((command, index) => {
    const last = groups[groups.length - 1];

    if (last && last.group === command.group) {
      last.items.push({ command, index });
    } else {
      groups.push({ group: command.group, items: [{ command, index }] });
    }
  });

  return groups;
}
